import React from "react";
import Text from "components/Text";
import { withTranslation } from "react-i18next";

function OfficesNamesCommon({ t, eventDetails, titleName }) {
  const getOfficeName = () => {
    if (eventDetails?.isEnterprise) {
      return t("scheduler.enterprise");
    }
    if (!eventDetails?.eventEmployees) return "";

    return (
      eventDetails?.eventEmployees[0]?.office?.name ??
      eventDetails?.eventEmployeeOfficeName ??
      eventDetails?.officeName ??
      eventDetails?.office?.name ??
      ""
    );
  };

  return (
    <>
      <Text size="12px" marginBottom="5px" weight="400" color="#6f7788">
        {titleName}
      </Text>
      <Text size="14px" marginBottom="0" weight="600" color="#102c42">
        {getOfficeName()}
      </Text>
    </>
  );
}

export default withTranslation()(OfficesNamesCommon);
